import Modal from "components/v2/Modal/Modal";
import { FormattedMessage } from "react-intl";

import RequestSelectionCard from "./RequestSelectionCard";
import useGetRequestSelectionOptions from "./useGetRequestSelectionOptions";
import "./RequestSelectionModal.scss";

interface RequestSelectionModalProps {
  show: boolean;
  onHide: () => void;
  requestSelectionModalConfig: {
    requestType: "quick_request" | "quote_request";
    showOCRSelection: boolean;
    showConsolidationSelection: boolean;
  };
}

export default function RequestSelectionModal({ show, onHide, requestSelectionModalConfig }: RequestSelectionModalProps) {
  const { requestType, showOCRSelection, showConsolidationSelection } = requestSelectionModalConfig;
  const { getQuoteRequestSelectionOptions, getQuickRequestSelectionOptions } = useGetRequestSelectionOptions({
    showOCRSelection,
    showConsolidationSelection,
  });
  const requestSelectionOptions =
    requestType === "quick_request" ? getQuickRequestSelectionOptions : getQuoteRequestSelectionOptions;

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header showDivider>
        <div className="text-primary text-xl font-semibold mb-3xl">
          {requestType === "quick_request" ? (
            <FormattedMessage
              id="requestSelectionModal.quickRequest.createNewQuickRequest"
              defaultMessage="Create new quick request"
            />
          ) : (
            <FormattedMessage
              id="requestSelectionModal.quoteRequest.createNewQuoteRequest"
              defaultMessage="Create new quote request"
            />
          )}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="request-selection-modal-grid">
          {requestSelectionOptions.map((requestSelection) => (
            <div key={requestSelection.title}>
              <RequestSelectionCard requestSelection={requestSelection} onHide={onHide} />
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
}
